import styles from './RadioGroup.module.scss'

import { IRadioInputData, IRadioInputSettings } from '../inputs.interface'

import { v4 as uuidv4 } from 'uuid'
import Radio from './components/Radio/Radio'
import { IChangeValue, IInputData } from '../../../interface/steps.interface'
import { IInputStatus } from '../../../interface/progress.interface'

interface Props {
  handleChange: IChangeValue
  settings: IInputData
  value: string
  name: string
  status: IInputStatus
}

const RadioGroup = ({ value: currentValue, name, handleChange, settings, status }: Props) => {
  const { options, emptyErrorText } = settings
  return (
    <div>
      <div className={styles.radio}>
        {options.map((option: IRadioInputData) => {
          const key = uuidv4()
          const { label, value } = option
          const settings = { name, label } as IRadioInputSettings

          return (
            <Radio
              value={String(value)}
              currentValue={String(currentValue)}
              handleChange={handleChange}
              settings={settings}
              key={key}
            />
          )
        })}
      </div>
        {status === IInputStatus.error && (
          <div className={styles.error}>{emptyErrorText}</div>
        )}
    </div>
  )
}

export default RadioGroup
